import React, { useContext, useEffect, useRef, useState } from "react";
import InputRegister from "../../../../blocks/ui/InputRegister";
import SelectInput from "../../../../blocks/ui/SelectInput";
import { maritalOptions } from "../../../../../data/dropdownOptions";
import { DContext } from "../../../../../context/Datacontext";

const initialProfile = {
  firstname: "",
  middlename: "",
  lastname: "",
  fullname: "",
  email: "",
  alternateemail: "",
  panNumber: "",
  contact: {
    countryCode: "+91",
    number: "",
  },
  alternatecontact: {
    countryCode: "+91",
    number: "",
  },
  gender: "",
  dob: "",
  maritalstatus: "",
};

export const PersonalInfo = ({ Information, errors, checkValidation, candidate }) => {
  const { isAuth, currentUser } = useContext(DContext);
  const [profile, setProfile] = useState(initialProfile);
  const firstRender = useRef(true);


  useEffect(() => {
    if (isAuth && currentUser && candidate) {

      const names = candidate?.fullName ? candidate?.fullName.split(" ") : [];

      const renderFullName = () => {
        let fullName = ""
        if (candidate.applicantName) {
          return candidate.applicantName
        }
        if (candidate.firstName) {
          fullName += candidate.firstName
          if (candidate?.lastName) {
            fullName += `${candidate?.lastName}`
          }
        }
        else {
          return candidate?.fullName || ""
        }

        return fullName || ""
      }

      setProfile((prev) => ({
        ...prev,
        firstname: candidate?.firstName || names[0] || profile.firstname || "",
        lastname: candidate?.lastName || names[1] || profile.lastname || "",
        fullname: renderFullName() || profile.fullname || "",
        email: candidate?.emailAddress || profile.email || "",
        contact: {
          countryCode: "+91",
          number: (candidate?.phoneNumber?.number || profile?.contact?.number || "").toString() || "",
        },
        panNumber: candidate?.panNumber || profile.panNumber || "",
        middlename: candidate?.middleName || profile.middlename || "",
        alternateemail: candidate?.alternateEmailAddress || profile.alternateemail || "",
        alternatecontact: {
          countryCode: candidate?.alternatePhoneNumber?.countryCode || "+91",
          number: candidate?.alternatePhoneNumber?.number || profile.alternatecontact.number || "",
        },
        gender: candidate?.gender || profile.gender || "",
        dob: formatDateDDMMYYYY(candidate?.dateOfBirth || profile.dob) || "",
        maritalstatus: candidate?.maritalStatus || profile.maritalstatus || "",
      }));
    }
  }, [isAuth, currentUser, candidate]);

  const formatDateDDMMYYYY = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    if (candidate === 0) {
      setProfile(prev => {
        let tempProfile = { ...prev }
        tempProfile.gender = candidate.gender || ""
        tempProfile.dob = candidate.dateOfBirth || ""
        tempProfile.maritalstatus = candidate.maritalStatus || ""
        return tempProfile
      })
    }
  }, [candidate])


  //Update field & auto update fullname
  const updateField = (field, value) => {
    setProfile((prev) => {
      const next = { ...prev, [field]: value.trim() };

      if (["firstname", "middlename", "lastname"].includes(field)) {
        const f = field === "firstname" ? value : prev.firstname;
        const m = field === "middlename" ? value : prev.middlename;
        const l = field === "lastname" ? value : prev.lastname;
        next.fullname = `${f || ""} ${m || ""} ${l || ""}`.replace(/\s+/g, " ").trim();
      }
      return next;
    });

    checkValidation(field, value)
  };

  //Update main contact
  const updateContact = (label, field, value) => {
    setProfile((prev) => ({
      ...prev,
      [label]: {
        ...prev[label],
        [field]: value.trim(),
      },
    }));

    checkValidation(field, value, label)
  };


  //Call Information only after first render
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (Information) {
      Information(profile);
    }
  }, [Information, profile]);

  // DOB restriction format 
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())
    .toISOString()
    .split("T")[0];
  // console.log("errors.fullname", errors.fullname)

  return (
    <div>
      <form className="mt-10">
        <div className="grid grid-cols-1 md:grid-cols-2  md:gap-3">
          <InputRegister
            label="First Name"
            value={profile.firstname}
            onChange={(e) => updateField("firstname", e.target.value)}
            placeholder="First name"
            error={errors.firstname || ""}
            className="w-full"
            mandatory={true}
          />

          <InputRegister
            label="Middle Name"
            value={profile.middlename}
            onChange={(e) => updateField("middlename", e.target.value)}
            placeholder="Middle name"
            className="w-full"
          />

          <InputRegister
            label="Last Name"
            value={profile.lastname}
            onChange={(e) => updateField("lastname", e.target.value)}
            placeholder="Last name"
            error={errors.lastname || ""}
            className="w-full"
            mandatory={true}
          />

          <InputRegister
            label="Full Name"
            value={profile.fullname}
            onChange={(e) => updateField("fullname", e.target.value)}
            placeholder="Full name"
            className="w-full"
            mandatory={true}
            error={errors.fullname}
          />

          {/* Email (readonly) */}
          <InputRegister
            label="Email"
            value={profile.email}
            onChange={(e) => updateField("email", e.target.value)}
            placeholder="Email"
            className="w-full"
            type="email"

            mandatory={true}
            error={errors.email}

          />

          {/* Alternate Email */}
          <InputRegister
            label="Alternate Email"
            value={profile.alternateemail}
            onChange={(e) => updateField("alternateemail", e.target.value)}
            placeholder="Alternate email"
            className="w-full"
            type="email"
            error={errors.alternateemail}
          />

          {/* Main Contact */}
          <div className="mt-1">
            <label className="block text-sm font-medium mb-1 text-gray-600">
              Contact number <sup className="text-red-500 text-sm"> *</sup>
            </label>
            <div className="flex gap-2 items-center">
              <div>
                <select
                  value={profile.contact.countryCode}
                  onChange={(e) => updateContact("contact", "countryCode", e.target.value)}
                  className="shadow rounded-l-lg bg-white px-3 py-3 focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:border-indigo-300 text-sm"
                  style={{ minWidth: "50px" }}

                >
                  <option value="+91">+91</option>
                  <option value="+1">+1</option>
                  <option value="+44">+44</option>
                  <option value="+61">+61</option>
                </select>
              </div>

              {/* Phone number */}
              <input
                type="tel"

                value={profile.contact.number}
                onChange={(e) => updateContact("contact", "number", e.target.value)}
                placeholder="Phone number"
                className="w-full shadow rounded-r-lg px-3 py-3 focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:border-indigo-300 text-sm"
              />
            </div>
            {(errors.contactCode || errors.contactNumber) && (
              <div className=" bg-red-100 rounded-lg h-auto">
                {errors.contactCode && <p className="text-red-500 text-sm mt-1 ml-3">{errors.contactCode}</p>}
                {errors.contactNumber && <p className="text-red-500 text-sm mt-1 ml-3">{errors.contactNumber}</p>}
              </div>
            )}
          </div>

          {/* Alternate Contact */}
          <div className="my-2">
            <label className="block text-sm font-medium mb-1 text-gray-600">
              Alternate Contact Number
            </label>
            <div className="flex gap-2 items-center">
              <div>
                <select
                  value={profile.alternatecontact.countryCode}
                  onChange={(e) => updateContact("alternatecontact", "countryCode", e.target.value)}
                  className="shadow rounded-l-lg bg-white px-3 py-3 focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:border-indigo-300 text-sm"
                  style={{ minWidth: "50px" }}
                >
                  <option value="+91">+91</option>
                  <option value="+1">+1</option>
                  <option value="+44">+44</option>
                  <option value="+61">+61</option>
                </select>
              </div>
              <div className="flex-1">
                <input
                  type="tel"
                  value={profile.alternatecontact.number}
                  onChange={(e) => updateContact("alternatecontact", "number", e.target.value)}
                  placeholder="Alternate contact number"
                  className="w-full shadow rounded-r-lg px-3 py-3 focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:border-indigo-300 text-sm"
                />
              </div>
            </div>
            {(errors.alternateContactCode || errors.alternateContactNumber) && (
              <div className="bg-red-100 rounded-md h-auto">
                {errors.alternateContactCode && <p className="text-red-500 text-sm mt-1 ml-3">{errors.alternateContactCode}</p>}
                {errors.alternateContactNumber && <p className="text-red-500 text-sm mt-1 ml-3">{errors.alternateContactNumber}</p>}
              </div>
            )}
          </div>

          {/* Gender */}
          <SelectInput
            label="Gender"
            value={profile?.gender || ""}
            onChange={e => updateField("gender", e.target.value)}
            options={[
              { label: "Male", value: "male" },
              { label: "Female", value: "female" },
              { label: "Other", value: "other" },
            ]}
            placeholder="Gender"
            className="w-full"
            mandatory={true}
            error={errors.gender}
          />

          {/* Date of Birth */}
          <InputRegister
            label="Date of Birth"
            value={profile.dob}
            onChange={(e) => updateField("dob", e.target.value)}
            placeholder="Date of Birth"
            type="date"
            className="w-full"
            mandatory={true}
            error={errors.dob}
            max={maxDate}
          />

          {/* Marital Status */}
          <SelectInput
            label="Marital Status"
            value={profile?.maritalstatus || ""}
            onChange={e => updateField("maritalstatus", e.target.value)}
            options={maritalOptions}
            placeholder="Marital Status"
            className="w-full"
          // mandatory={true}
          // error={errors.maritalstatus}
          />

          {/* Alternate Email */}
          <InputRegister
            label="PAN Number"
            value={profile.panNumber}
            onChange={(e) => updateField("panNumber", e.target.value)}
            placeholder="PAN Number"
            className="w-full"
            type="text"
            error={errors.panNumber}
          />
        </div>
      </form>
    </div>
  );
};
